import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CookieBanner from "react-cookie-banner";
import SMSAuth from "components/Auth/SMSAuth";

import Cookies from "./static/Cookies";
import Login from "./auth/Login";
import Home from "./Home";
import MobileMenu from "./MobileMenu";
import Menu from "./Menu";
import Footer from "./Footer";
import Dashboard from "./Dashboard";
import UserProfile from "./profile/UserProfile";
import Message from "components/Auth/Message";

import Account from "./admin/accounts/Account";
import AdminAccount from "./admin/accounts/AccountDetails";
import AdminAccounts from "./admin/accounts/AccountList";
import AdminUser from "./admin/users/UserDetails";
import AdminUsers from "./admin/users/UserList";
import Brands from "./brands/BrandsPage";
import Brand from "./brands/BrandPage";
import BrandCategory from "./brands/BrandCategoryPage";
import BrandCategoryProduct from "./brands/BrandCategoryProductPage";

import Reports from "./campaigns/Reports";
import Report from "./campaigns/Report";
import Campaigns from "./campaigns/Campaigns";
import Campaign from "./campaigns/Campaign";

import Transactions from "./transactions/Transactions";
import Notifications from "./notifications/Notifications";
import NotificationPage from "./notifications/NotificationPage";
import Bills from "./billing/Bills";

import Mediagroups from "./mediagroups/Mediagroups";
import Mediagroup from "./mediagroups/Mediagroup";

import Categories from "./channels/Categories";
import Category from "./channels/Category";

import AdminCategories from "./admin/categories/Categories";
import AdminCategory from "./admin/categories/Category";
import AdminMediagroups from "./admin/mediagroups/Mediagroups";
import AdminMediagroup from "./admin/mediagroups/Mediagroup";

import AdminProviders from "./admin/providers/Providers";
import AdminProvider from "./admin/providers/Provider";

import AdminPersons from "./admin/persons/Persons";
import AdminPerson from "./admin/persons/Person";

import AdminBrands from "./admin/brands/BrandsTablePage";
import AdminBrandCategory from "./admin/brands/BrandCategoryFormPage";

import AdminProducts from "./admin/products/Products";
import AdminProduct from "./admin/products/Product";

import AdminProductTypes from "./admin/producttypes/ProductTypeListPage";
import AdminProductType from "./admin/producttypes/ProductTypeFormPage";

import AdminSegments from "./admin/segments/Segments";
import AdminSegment from "./admin/segments/Segment";

import AdminOrders from "./admin/orders/Orders";
import AdminOrder from "./admin/orders/Order";

import AdminBrand from "./admin/brands/BrandFormPage";
import { BrowserRouter, Route, Redirect } from "react-router-dom";

import { auth, segments, categories, persons, mediagroups } from "data/actions";

function MatchRequireAuthed({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ match, location }) => {
        return authed === true ? (
          <Component {...rest} {...match} />
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: location } }} />
        );
      }}
    />
  );
}

function MatchRequireUnauthed({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ match }) => {
        return authed === true ? (
          <Redirect to="/medier" />
        ) : (
          <Component {...rest} {...match} />
        );
      }}
    />
  );
}

class AppRouter extends Component {
  static childContextTypes = {
    router: PropTypes.object,
    user: PropTypes.object
  };

  getChildContext() {
    return {
      router: this.props.router,
      user: this.props.user
    };
  }

  state = {
    authed: false,
    user: null,
    loading: true
  };
  componentDidMount() {
    this.props.actions.getAuthUser();
    this.props.actions.fetchSegments();
    this.props.actions.fetchCategories();
    this.props.actions.fetchPersons();
    this.props.actions.fetchMediagroups();
  }
  componentWillUnmount() {
    //this.removeListener();
  }

  toCookies = () => {
    this.context.router.history.push("/cookies");
  };

  render() {
    var cls = this.props.authed ? "AppRouter Authed  " : "AppRouter  ";
    return (
      <BrowserRouter>
        {this.props.loading ? (
          <span>Loading</span>
        ) : (
          <div className={cls} id="grid">
            <CookieBanner
              dismissOnScroll={false}
              buttonMessage="Ok"
              message="ONESTOP använder cookies för att ge dig bästa möjliga upplevelse av Webbplatsen."
              link={{ url: "/cookies", msg: "Läs mer", target: "_blank" }}
              onAccept={() => {}}
              cookie="user-has-accepted-cookies"
            />
            {this.props.user && this.props.user && this.props.user.activated ? null :  <SMSAuth user={this.props.user}/>  } 

            <Menu user={this.props.user} authed={this.props.authed} />
            <MobileMenu />

            <MatchRequireAuthed exact path="/" component={Home} />
            <MatchRequireUnauthed
              path="/login"
              authed={this.props.authed}
              component={Login}
              register={false}
            />
            <MatchRequireUnauthed
              path="/cookies"
              authed={false}
              component={Cookies}
              register={false}
            />
            <MatchRequireUnauthed
              path="/register"
              authed={this.props.authed}
              component={Login}
              register={true}
            />
            <MatchRequireAuthed
              path="/dashboard"
              authed={this.props.authed}
              component={Dashboard}
              user={this.props.user}
            />
            <MatchRequireAuthed
              path="/profile"
              authed={this.props.authed}
              component={UserProfile}
              user={this.props.user}
            />
            <MatchRequireAuthed
              path="/account"
              authed={this.props.authed}
              component={Account}
              user={this.props.user}
            />
            <MatchRequireAuthed
              exact
              path="/media/:brandid/:categoryid/:productid"
              authed={this.props.authed}
              component={BrandCategoryProduct}
            />
            <MatchRequireAuthed
              exact
              path="/media/:brandid/:categoryid"
              authed={this.props.authed}
              component={BrandCategory}
            />
            <MatchRequireAuthed
              exact
              path="/media/:id"
              authed={this.props.authed}
              component={Brand}
            />
            <MatchRequireAuthed
              path="/medier"
              authed={this.props.authed}
              component={Brands}
            />

<MatchRequireAuthed
              exact
              path="/rapporter/:id"
              user={this.props.user}
              authed={this.props.authed}
              component={Report}
            />
            <MatchRequireAuthed
              exact
              path="/rapporter"
              user={this.props.user}
              authed={this.props.authed}
              component={Reports}
            />
            <MatchRequireAuthed
              exact
              path="/kampanj/:id"
              user={this.props.user}
              authed={this.props.authed}
              component={Campaign}
            />
            <MatchRequireAuthed
              exact
              path="/kampanj"
              user={this.props.user}
              authed={this.props.authed}
              component={Campaigns}
            />
            <MatchRequireAuthed
              exact
              path="/transaktioner"
              user={this.props.user}
              authed={this.props.authed}
              component={Transactions}
            />
            <MatchRequireAuthed
              exact
              path="/fakturor"
              user={this.props.user}
              authed={this.props.authed}
              component={Bills}
            />
            <MatchRequireAuthed
              exact
              path="/meddelanden"
              user={this.props.user}
              authed={this.props.authed}
              component={Notifications}
            />
            <MatchRequireAuthed
              exact
              path="/meddelande/:accountid/:notificationid"
              user={this.props.user}
              authed={this.props.authed}
              component={NotificationPage}
            />

            <MatchRequireAuthed
              path="/mediehus/:id"
              authed={this.props.authed}
              component={Mediagroup}
            />
            <MatchRequireAuthed
              exact
              path="/mediehus"
              authed={this.props.authed}
              component={Mediagroups}
            />

            <MatchRequireAuthed
              path="/kanal/:id"
              authed={this.props.authed}
              component={Category}
            />
            <MatchRequireAuthed
              exact
              path="/kanaler"
              authed={this.props.authed}
              component={Categories}
            />

            <MatchRequireAuthed
              path="/admin/mediagroups"
              authed={this.props.authed}
              component={AdminMediagroups}
            />
            <MatchRequireAuthed
              path="/admin/mediagroup/:id"
              authed={this.props.authed}
              component={AdminMediagroup}
            />

            <MatchRequireAuthed
              path="/admin/providers"
              authed={this.props.authed}
              component={AdminProviders}
            />
            <MatchRequireAuthed
              path="/admin/provider/:id"
              authed={this.props.authed}
              component={AdminProvider}
            />

            <MatchRequireAuthed
              path="/admin/persons"
              authed={this.props.authed}
              component={AdminPersons}
            />
            <MatchRequireAuthed
              path="/admin/person/:id"
              authed={this.props.authed}
              component={AdminPerson}
            />

            <MatchRequireAuthed
              path="/admin/accounts"
              authed={this.props.authed}
              component={AdminAccounts}
            />
            <MatchRequireAuthed
              path="/admin/account/:id"
              authed={this.props.authed}
              component={AdminAccount}
            />

            <MatchRequireAuthed
              path="/admin/users"
              authed={this.props.authed}
              component={AdminUsers}
            />
            <MatchRequireAuthed
              path="/admin/user/:id"
              authed={this.props.authed}
              component={AdminUser}
            />

            <MatchRequireAuthed
              path="/admin/segments"
              authed={this.props.authed}
              component={AdminSegments}
            />
            <MatchRequireAuthed
              path="/admin/segment/:id"
              authed={this.props.authed}
              component={AdminSegment}
            />
            <MatchRequireAuthed
              path="/admin/brands"
              authed={this.props.authed}
              component={AdminBrands}
            />
            <MatchRequireAuthed
              exact
              path="/admin/brand/:brandid/:categoryid"
              authed={this.props.authed}
              component={AdminBrandCategory}
            />
            <MatchRequireAuthed
              exact
              path="/admin/brand/:id"
              authed={this.props.authed}
              component={AdminBrand}
            />

            <MatchRequireAuthed
              path="/admin/categories"
              authed={this.props.authed}
              component={AdminCategories}
            />
            <MatchRequireAuthed
              path="/admin/category/:id"
              authed={this.props.authed}
              component={AdminCategory}
            />

            <MatchRequireAuthed
              path="/admin/products"
              authed={this.props.authed}
              component={AdminProducts}
            />
            <MatchRequireAuthed
              path="/admin/product/:id"
              authed={this.props.authed}
              component={AdminProduct}
            />

            <MatchRequireAuthed
              path="/admin/producttypes"
              authed={this.props.authed}
              component={AdminProductTypes}
            />
            <MatchRequireAuthed
              path="/admin/producttype/:id"
              authed={this.props.authed}
              component={AdminProductType}
            />

            <MatchRequireAuthed
              path="/admin/orders"
              authed={this.props.authed}
              component={AdminOrders}
            />
            <MatchRequireAuthed
              path="/admin/order/:id"
              authed={this.props.authed}
              component={AdminOrder}
            />

            {this.props.messages && (
              <Message
                message={this.props.messages.message}
                ts={this.props.messages.time}
              />
            )}
            <Footer />
          </div>
        )}
      </BrowserRouter>
    );
  }
}

function mapStateToProps(state) {
  var pending = state.segments.list.pending;
  return {
    authed: !!state.auth.user,
    fbuser: state.auth.fbuser,
    user: state.auth.user,
    loading: !state.auth.ready,
    messages: state.messages
  };
}
const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...auth, ...segments, ...categories, ...persons, ...mediagroups },
      dispatch
    )
  };
};
export default connect(mapStateToProps, mapDispatch)(AppRouter);



// WEBPACK FOOTER //
// ./src/pages/AppRouter.jsx